import { theme } from 'settle-ui/theme'

export interface GetIconBoxDimensionsParams {
  fullSize?: boolean
  /**
   * - 'sm': Small (40px)
   * - 'medium': Medium (48px)
   * - 'large': Large (56px)
   * - 'xl': Extra Large (64px)
   * @default 'medium'
   */
  size?: 'sm' | 'medium' | 'large' | 'xl' | 'xxl'
}

export const getIconBoxDimensions = ({ size = 'medium', fullSize }: GetIconBoxDimensionsParams) => {
  let dimensions

  switch (size) {
    case 'xxl':
      dimensions = { size: 72, fontSize: fullSize ? '4.5rem' : '3rem' } as const
      break
    case 'xl':
      dimensions = { size: 64, fontSize: fullSize ? '4rem' : '2.5rem' } as const
      break
    case 'large':
      dimensions = { size: 56, fontSize: fullSize ? '3.5rem' : '2rem' } as const
      break
    case 'medium':
      dimensions = { size: 48, fontSize: fullSize ? '3rem' : '2rem' } as const
      break
    case 'sm':
      dimensions = { size: 40, fontSize: fullSize ? '2.5rem' : '1.5rem' } as const
      break
  }

  return {
    ...dimensions,
    iconSize: parseFloat(dimensions.fontSize) * theme.typography.htmlFontSize,
  }
}
